module.exports = __webpack_public_path__ + "img/Toyota-2019-Tundra-2.115d6320.png";